import React from 'react';
import { connect } from 'react-redux';
import {
  columnDescription,
  columnName,
  columnMultiSelect,
  columnCreatedOn,
  columnUpdatedOn,
  columnTools,
  columnVisibility,
  columnStatus,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';
import { toggleCohortsSelected } from '../actions';

const CohortsTableColumns = ({
  category,
  items,
  onCheckBoxClick,
  columns = [
    columnMultiSelect,
    columnName,
    columnDescription,
    columnCreatedOn,
    columnUpdatedOn,
    columnVisibility,
    columnTools],
}) => (
  <NameDescriptionColumns
    entity="cohort"
    onCheckBoxClick={({ selected }) => onCheckBoxClick(category, selected)}
    items={items}
    columns={columns}
  >
    {hasColumn(columns, columnVisibility) && (<UnsortedColumn columnId={columnVisibility} />)}
    {hasColumn(columns, columnCreatedOn) && (<UnsortedColumn columnId={columnCreatedOn} />)}
    {hasColumn(columns, columnUpdatedOn) && (<UnsortedColumn columnId={columnUpdatedOn} />)}
    {hasColumn(columns, columnStatus) && (<UnsortedColumn columnId={columnStatus} />)}
  </NameDescriptionColumns>
);

const mapDispatchToProps = {
  onCheckBoxClick: toggleCohortsSelected,
};

export default connect(null, mapDispatchToProps)(CohortsTableColumns);
